module.exports = __webpack_public_path__ + "static/media/ms.5697cedd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/ms.jpg
// module id = 58
// module chunks = 0